import { scaledRemCalc } from '@mnd-frontend/utils';
import styled from 'styled-components';

interface LegendProps {
  color: string;
  size?: number;
  $inactive?: boolean;
}

const LegendIcon = styled.i<LegendProps>`
  display: inline-block;
  flex-shrink: 0;
  background-color: ${({ color }) => color};
  border-radius: ${({ size = 1 }) => scaledRemCalc(size * 4)};
  width: ${({ size = 1 }) => scaledRemCalc(size * 16)};
  height: ${({ size = 1 }) => scaledRemCalc(size * 16)};
  margin-right: ${scaledRemCalc(8)};
  opacity: ${({ $inactive = false }) => ($inactive ? 0.3 : 1.0)};
`;

export default LegendIcon;
